import gql from 'graphql-tag';
import workspaceFragment from '../fragments/workspace';
import placeFragment from '../fragments/place';

const GET_CURRENT_USER = gql`
  query getCurrentUser {
    getCurrentUser {
      id
      firstName
      lastName
      email
      currentWorkspace
      config
      profilePicture
      superAdmin
      userRoles {
        id
        systemId
        account {
          id
        }
        workspace {
          ...workspaceDetails
        }
        role {
          id
          name
          resourceId
        }
        customer {
          id
          name
          identifier
          workspaceId
          image
          devices {
            id
            name
            connectionStatus
            image
            workspacePrefix {
              prefix
            }
            uniqueId
            type
            customerId
            createdAt
            isPushNotificationsEnabled
            isMonitorable
            isActive
            lastDevicePosition
            devicePlaces {
              placeId
              place {
                ...placeDetails
              }
            }
          }
        }
        device {
          id
          name
          connectionStatus
          image
          workspacePrefix {
            prefix
          }
          uniqueId
          type
          customerId
          createdAt
          isPushNotificationsEnabled
          isMonitorable
          isActive
          lastDevicePosition
          customer {
            id
            name
          }
          devicePlaces {
            placeId
            place {
              ...placeDetails
            }
          }
        }
      }
    }
  }
  ${workspaceFragment.FRAGMENT_WORKSPACE}
  ${placeFragment.FRAGMENT_PLACE}
`;

const IS_USER_REGISTERED = gql`
  query isUserRegistered($email: String!) {
    isUserRegistered(email: $email)
  }
`;

const GET_USER_BY_ID = gql`
  query GetUserById($userId: ID!) {
    getUserById(userId: $userId) {
      id
      firstName
      lastName
      currentWorkspace
      phone
    }
  }
`;

export default {
  GET_CURRENT_USER,
  GET_USER_BY_ID,
  IS_USER_REGISTERED,
};
